var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33979 10.3398C11.0189 8.66071 11.0189 5.93839 9.33979 4.25931C7.66071 2.58023 4.93839 2.58023 3.25931 4.25931C1.58023 5.93839 1.58023 8.66071 3.25931 10.3398C4.93839 12.0189 7.66071 12.0189 9.33979 10.3398ZM9.33979 10.3398L12 13",
    stroke: "#8B8A8A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearchIcon);
export default __webpack_public_path__ + "static/media/input-search-icon.13a0d7ce8d85f8933c1bf2fc91c8b441.svg";
export { ForwardRef as ReactComponent };